/**
 * Builds the router state the Everybody Wins page (/everybody-wins) renders from.
 *
 * - 'team' mode: the club card mapped to `teamCode`. With `randomTeamFallback`, a participant
 *   with no club (or one that isn't mapped) gets a random mapped club instead of no card.
 * - 'tiered' mode: one random player from each tier pool.
 */
const randomItem = (items) => items[Math.floor(Math.random() * items.length)];

export function buildEverybodyWinsState(brand, { teamCode = '', participantName = '', randomTeamFallback = false } = {}) {
  const ew = brand?.everybody_wins;
  const campaignName = brand?.campaign?.name || '';

  if (ew?.mode === 'team') {
    const shortCode = String(teamCode || '').toUpperCase();
    const mappings = (ew.team_mappings || []).filter((m) => m?.image);
    let match = mappings.find((m) => (Array.isArray(m.short_codes) ? m.short_codes : []).includes(shortCode));
    if (!match && randomTeamFallback && mappings.length > 0) match = randomItem(mappings);
    const name = match ? match.name || (match.short_codes?.includes(shortCode) ? shortCode : match.short_codes?.[0]) || '' : '';
    return {
      mode: 'team',
      teamImage: match ? { image: match.image, name } : null,
      participantName,
      campaignName
    };
  }

  const tiers = [ew?.tier1_players, ew?.tier2_players, ew?.tier3_players, ew?.tier4_players];
  const players = tiers.map((pool, i) => {
    const picked = Array.isArray(pool) && pool.length > 0 ? randomItem(pool) : null;
    return { tier: i + 1, image: picked?.image || picked || '', name: picked?.name || '' };
  });
  return { players, participantName, campaignName };
}

/** The club short code from the participant's saved profile (set when they submit an entry). */
export function readSavedTeamCode() {
  try {
    return JSON.parse(localStorage.getItem('participantProfile'))?.preferred_team || '';
  } catch {
    return '';
  }
}
